import {Component, ElementRef, Input, NgZone, Renderer2, ViewChild} from '@angular/core';
import {MessageService} from '../../../../../providers/message-service';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'hc-action',
    templateUrl: 'hc-action.html',
    providers: []
})
export class HcAction {

    public window = window;

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;
    @Input('index') index: number;
    @Input('first') first: boolean;

    videoPrepared = false;
    videoEnded = false;

    @ViewChild('videoTag') video: any;

    constructor(public element: ElementRef, private ngZone: NgZone, private renderer: Renderer2, private messageService: MessageService) {

        this.messageService.get('galeria.menu.dismiss').subscribe(() => {
            this.actionPlay()
        })

    }

    actionPlay(video?: HTMLVideoElement) {

        video = video || (this.video && this.video.nativeElement);

        if (!video) {
            return;
        }

        video.volume = 0;

        if (this.videoPrepared) {
            if (video.paused) video.play();
            return;
        }
        this.videoPrepared = true;

        if (!this.hpage.rootdata.Galerias.Alertas.length) video.play();

        video.onended = () => {

            this.renderer.addClass(video, 'blur-1');
            setTimeout(() => {
                this.renderer.addClass(video, 'blur-2');
                setTimeout(() => {
                    this.renderer.addClass(video, 'blur-3');
                    setTimeout(() => {
                        this.renderer.addClass(video, 'blur-4');
                        setTimeout(() => {
                            this.renderer.addClass(video, 'blur-5');
                            setTimeout(() => {

                                video.play();
                                if (video.nextElementSibling) return;
                                video.loop = true;

                                this.ngZone.run(() => {

                                    this.videoEnded = true;

                                    setTimeout(() => {
                                        this.renderer.setStyle(video.nextElementSibling, 'height', video.clientHeight + 'px');
                                        this.messageService.get('website.rola').next({id: this.hpage.rootdata.Hotspots[0].HotspotID});
                                    });

                                });

                            }, 100);
                        }, 100);
                    }, 100);
                }, 100);
            }, 100);

        };

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/hc-action/hc-action.ts